/* RJ Recreation Edit (October CRO draft), ported from the BF draft gift guide. No dependencies.
   Custom events only (gift_guide_*, charm_bar_cta_click): no standard add_to_cart/purchase events are fired here. */
(function () {
  if (window.__rjEdit) return;
  window.__rjEdit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STR = function () { return window.RJ_GIFT_GUIDE_STRINGS || { add: 'Add [title] to bag', options: 'Choose options for [title]', showing: 'Showing [edit]' }; };

  /* ---------- analytics: Shopify customer events + dataLayer (if present) ---------- */
  function track(name, data) {
    data = data || {};
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {}
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('rj:analytics', { detail: { name: name, data: data } })); } catch (e) {}
  }
  function remember(category, itemId) {
    try { sessionStorage.setItem('rj_gift_guide_source', JSON.stringify({ category: category, item_id: itemId || null, ts: Date.now() })); } catch (e) {}
  }

  /* ---------- gift guide ---------- */
  function GiftGuide(root) {
    this.root = root;
    this.mode = root.getAttribute('data-mode') || 'everyday';
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    this.live = root.querySelector('[data-rj-live]');
    this.tabList = root.querySelector('[role="tablist"]');
    var self = this;

    this.tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { self.select(i, true); });
      tab.addEventListener('keydown', function (e) { self.onKey(e, i); });
    });

    this.activePanel().removeAttribute('hidden');
    this.prepare(this.activePanel());

    root.addEventListener('click', function (e) { self.onClick(e); });
    root.addEventListener('keydown', function (e) {
      var qa = e.target.closest && e.target.closest('quick-view.product-card--add-to-cart-button');
      if (qa && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); qa.click(); }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            track('gift_guide_view', { gift_guide_mode: self.mode, gift_category: self.currentCategory(), category_count: self.tabs.length });
            io.disconnect();
          }
        });
      }, { threshold: 0.35 });
      io.observe(root);
    }
  }

  GiftGuide.prototype.currentIndex = function () {
    for (var i = 0; i < this.tabs.length; i++) if (this.tabs[i].getAttribute('aria-selected') === 'true') return i;
    return 0;
  };
  GiftGuide.prototype.currentCategory = function () {
    var t = this.tabs[this.currentIndex()];
    return t ? t.getAttribute('data-category') : '';
  };
  GiftGuide.prototype.activePanel = function () {
    var t = this.tabs[this.currentIndex()];
    return this.root.querySelector('#' + t.getAttribute('aria-controls'));
  };

  GiftGuide.prototype.onKey = function (e, i) {
    var n = this.tabs.length, next = null;
    if (e.key === 'ArrowRight') next = (i + 1) % n;
    else if (e.key === 'ArrowLeft') next = (i - 1 + n) % n;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = n - 1;
    if (next === null) return;
    e.preventDefault();
    this.select(next, true);
    this.tabs[next].focus();
  };

  GiftGuide.prototype.select = function (i, user) {
    var current = this.currentIndex();
    if (i === current) return;
    var self = this;
    this.tabs.forEach(function (tab, j) {
      var on = j === i;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.setAttribute('tabindex', on ? '0' : '-1');
      var panel = self.root.querySelector('#' + tab.getAttribute('aria-controls'));
      if (!panel) return;
      if (on) {
        self.hydrate(panel);
        panel.removeAttribute('hidden');
        panel.classList.remove('is-entering');
        void panel.offsetWidth;
        panel.classList.add('is-entering');
        var trk = panel.querySelector('[data-rj-track]');
        if (trk) trk.scrollLeft = 0;
        self.prepare(panel);
      } else {
        panel.setAttribute('hidden', '');
      }
    });
    this.revealTab(this.tabs[i]);
    var name = this.tabs[i].getAttribute('data-category');
    if (this.live) this.live.textContent = STR().showing.replace('[edit]', name);
    if (user) track('gift_guide_select_category', { gift_guide_mode: this.mode, gift_category: name, category_index: i + 1 });
  };

  GiftGuide.prototype.revealTab = function (tab) {
    var list = this.tabList;
    if (!list || list.scrollWidth <= list.clientWidth) return;
    // Centre the chosen tab. Instant on purpose: smooth scrolling on a short row was
    // being interrupted by the panel swap, leaving the selected tab off-screen.
    var left = tab.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2;
    list.scrollLeft = Math.max(0, Math.min(left, list.scrollWidth - list.clientWidth));
  };

  GiftGuide.prototype.hydrate = function (panel) {
    var tpl = panel.querySelector('template[data-rj-deferred]');
    if (!tpl) return;
    var frag = tpl.content ? document.importNode(tpl.content, true) : null;
    if (frag) panel.insertBefore(frag, tpl);
    tpl.parentNode.removeChild(tpl);
  };

  GiftGuide.prototype.prepare = function (panel) {
    if (panel.__rjReady) { this.updateControls(panel); return; }
    panel.__rjReady = true;
    var strings = STR();
    // Accessible quick add: the theme renders it as a non-focusable element.
    Array.prototype.forEach.call(panel.querySelectorAll('[data-rj-item]'), function (slide) {
      var qa = slide.querySelector('quick-view.product-card--add-to-cart-button');
      if (!qa || qa.hasAttribute('disabled')) return;
      var title = slide.getAttribute('data-item-name') || '';
      var direct = slide.getAttribute('data-options') === 'direct';
      qa.setAttribute('role', 'button');
      qa.setAttribute('tabindex', '0');
      qa.setAttribute('aria-label', (direct ? strings.add : strings.options).replace('[title]', title));
    });
    var track = panel.querySelector('[data-rj-track]');
    var controls = panel.querySelector('[data-rj-controls]');
    if (!track || !controls) return;
    var self = this;
    var prev = controls.querySelector('[data-rj-prev]');
    var next = controls.querySelector('[data-rj-next]');
    var step = function (dir) {
      var amount = Math.max(track.clientWidth * 0.85, 200) * dir;
      try { track.scrollBy({ left: amount, behavior: reduceMotion ? 'auto' : 'smooth' }); } catch (e) { track.scrollLeft += amount; }
    };
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      window.requestAnimationFrame(function () { ticking = false; self.updateControls(panel); });
    }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(function () { self.updateControls(panel); }).observe(track);
    this.updateControls(panel);
  };

  GiftGuide.prototype.updateControls = function (panel) {
    var track = panel.querySelector('[data-rj-track]');
    var controls = panel.querySelector('[data-rj-controls]');
    if (!track || !controls) return;
    var max = track.scrollWidth - track.clientWidth;
    controls.hidden = max <= 4;
    if (max <= 4) return;
    var bar = controls.querySelector('[data-rj-progress]');
    var ratio = track.clientWidth / track.scrollWidth;
    var pos = track.scrollLeft / max;
    if (bar) { bar.style.width = (ratio * 100).toFixed(2) + '%'; bar.style.transform = 'translateX(' + (pos * (1 / ratio - 1) * 100).toFixed(2) + '%)'; }
    var prev = controls.querySelector('[data-rj-prev]');
    var next = controls.querySelector('[data-rj-next]');
    if (prev) prev.disabled = track.scrollLeft <= 4;
    if (next) next.disabled = track.scrollLeft >= max - 4;
  };

  GiftGuide.prototype.onClick = function (e) {
    var t = e.target;
    var category = this.currentCategory();
    if (t.closest('[data-rj-view-all]')) {
      track('gift_guide_view_all', { gift_guide_mode: this.mode, gift_category: category });
      remember(category);
      return;
    }
    var slide = t.closest('[data-rj-item]');
    if (!slide) return;
    var base = {
      gift_guide_mode: this.mode,
      gift_category: category,
      item_id: slide.getAttribute('data-item-id'),
      item_name: slide.getAttribute('data-item-name'),
      price: Number(slide.getAttribute('data-item-price')) || undefined,
      index: Number(slide.getAttribute('data-item-index')) || undefined
    };
    if (t.closest('quick-view.product-card--add-to-cart-button')) {
      base.quick_add_type = slide.getAttribute('data-options') === 'direct' ? 'direct' : 'options';
      track('gift_guide_quick_add', base);
      remember(category, base.item_id);
    } else if (t.closest('a[href*="/products/"]')) {
      track('gift_guide_select_item', base);
      remember(category, base.item_id);
    }
  };

  /* ---------- simple product row (bestsellers) ---------- */
  function ProductRow(root) {
    var name = root.getAttribute('data-rj-row') || 'row';
    var panel = root.querySelector('[data-rj-panel]') || root;
    GiftGuide.prototype.prepare.call({ updateControls: GiftGuide.prototype.updateControls }, panel);
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-rj-view-all]')) { track(name + '_view_all', {}); return; }
      var slide = t.closest('[data-rj-item]');
      if (!slide) return;
      var base = { item_id: slide.getAttribute('data-item-id'), item_name: slide.getAttribute('data-item-name'), price: Number(slide.getAttribute('data-item-price')) || undefined, index: Number(slide.getAttribute('data-item-index')) || undefined };
      if (t.closest('quick-view.product-card--add-to-cart-button')) { base.quick_add_type = slide.getAttribute('data-options') === 'direct' ? 'direct' : 'options'; track(name + '_quick_add', base); }
      else if (t.closest('a[href*="/products/"]')) track(name + '_select_item', base);
    });
    root.addEventListener('keydown', function (e) {
      var qa = e.target.closest && e.target.closest('quick-view.product-card--add-to-cart-button');
      if (qa && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); qa.click(); }
    });
  }

  /* ---------- category shortcuts ---------- */
  function CategoryNav(root) {
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-rj-cat]');
      if (a) track('home_category_click', { category: a.getAttribute('data-rj-cat'), link_url: a.getAttribute('href') });
    });
  }

  /* ---------- charm bar band ---------- */
  function CharmBand(root) {
    root.addEventListener('click', function (e) {
      var cta = e.target.closest('[data-rj-cb-cta]');
      if (cta) { track('charm_bar_cta_click', { cta: cta.getAttribute('data-rj-cb-cta'), link_url: cta.getAttribute('href') }); return; }
      var charm = e.target.closest('[data-rj-cb-charm]');
      if (charm) track('charm_bar_charm_click', { item_id: charm.getAttribute('data-item-id'), item_name: charm.getAttribute('data-item-name') });
    });
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-rj-gift-guide]'), function (el) {
      if (el.__rjGG) return; el.__rjGG = new GiftGuide(el);
    });
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-rj-charm-bar]'), function (el) {
      if (el.__rjCB) return; el.__rjCB = new CharmBand(el);
    });
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-rj-row]'), function (el) {
      if (el.__rjRow) return; el.__rjRow = new ProductRow(el);
    });
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-rj-cat-nav]'), function (el) {
      if (el.__rjCat) return; el.__rjCat = new CategoryNav(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Theme editor: re-init when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.closest && e.target.closest('[role="tab"]');
    var root = tab && tab.closest('[data-rj-gift-guide]');
    if (root && root.__rjGG) root.__rjGG.select(root.__rjGG.tabs.indexOf(tab), false);
  });
})();
